export default "__VITE_ASSET__BcGSshl6__"